import { render, staticRenderFns } from "./HbInfoCard.vue?vue&type=template&id=25779f20&scoped=true&"
import script from "./HbInfoCard.vue?vue&type=script&lang=js&"
export * from "./HbInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./HbInfoCard.vue?vue&type=style&index=0&id=25779f20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25779f20",
  null
  
)

export default component.exports